import { render, staticRenderFns } from "./StartNewForm.vue?vue&type=template&id=0f7f7b93&scoped=true"
import script from "./StartNewForm.vue?vue&type=script&lang=js"
export * from "./StartNewForm.vue?vue&type=script&lang=js"
import style0 from "./StartNewForm.vue?vue&type=style&index=0&id=0f7f7b93&prod&scoped=true&lang=css"
import style1 from "./StartNewForm.vue?vue&type=style&index=1&id=0f7f7b93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f7b93",
  null
  
)

export default component.exports